// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../ListComponent.styles';
import { Text } from '../../../BuildingBlocks/Text';
import { Search } from '../../../BuildingBlocks/Search';
import { FilterToggle } from '../FilterToggle';
import { sortFilterShape, viewFilterShape } from '../lib/ListComponent.shapes';

function Header(props) {
  const {
    filterProps,
    constants,
    searchProps,
    currentView,
    toggleProps,
    hideViewToggle,
    hideViewFilter,
    hideSortFilter,
    hideFilters,
    hideSearch,
    searchLabelText,
    helpText,
    searchOnClick,
    onKeyPressEnter,
    placeholder
  } = props;

  return (
    <Styled.ListHeader>
      <Styled.SearchContainer>
        {!hideSearch && (
          <Search
            height={64}
            icon={<Styled.SearchSVG selectedIcon="search" />}
            labelText={searchLabelText}
            disableFlyout
            clearValue={searchProps.clearValue}
            onChange={searchProps.onChange}
            onClickHook={searchOnClick}
            onSubmitHook={onKeyPressEnter}
            placeholder={placeholder}
            value={searchProps.value}
            noButton
          />
        )}
      </Styled.SearchContainer>
      {helpText && (
        <Styled.HelpText>
          <Text.CopyMini color="tertiary">{helpText}</Text.CopyMini>
        </Styled.HelpText>
      )}
      {!hideFilters && (
        <Styled.SortHeader>
          {!hideViewFilter && (
            <FilterToggle
              label="View"
              filterType={filterProps.viewFilterType}
              open={filterProps.dropdownOpen === constants.VIEW_FILTER_OPEN}
              currentFilter={filterProps.currentViewFilter}
            />
          )}
          {!hideSortFilter && (
            <FilterToggle
              label="Sort By"
              filterType={filterProps.sortFilterType}
              open={filterProps.dropdownOpen === constants.SORT_FILTER_OPEN}
              currentFilter={filterProps.currentSortFilter}
            />
          )}
        </Styled.SortHeader>
      )}
      {!hideViewToggle && (
        <Styled.ToggleContainer>
          <Styled.ToggleButton
            className={currentView === constants.CARD_VIEW ? 'active-view' : undefined}
            selectedIcon="cardViewToggle"
            onClick={() => toggleProps.handleViewToggle(constants.CARD_VIEW)}
          />
          <Styled.ToggleButton
            className={currentView === constants.TABLE_VIEW ? 'active-view' : undefined}
            selectedIcon="tableViewToggle"
            onClick={() => toggleProps.handleViewToggle(constants.TABLE_VIEW)}
          />
        </Styled.ToggleContainer>
      )}
    </Styled.ListHeader>
  );
}

Header.propTypes = {
  hideViewToggle: PropTypes.bool,
  hideViewFilter: PropTypes.bool,
  hideSortFilter: PropTypes.bool,
  hideFilters: PropTypes.bool,
  hideSearch: PropTypes.bool,
  searchLabelText: PropTypes.string,
  searchOnClick: PropTypes.func,
  helpText: PropTypes.string,
  filterProps: PropTypes.shape({
    viewFilterType: PropTypes.shape({
      handleDropdownClose: PropTypes.func,
      handleDropdownOpen: PropTypes.func,
      defaultFilter: sortFilterShape,
      filterCollection: PropTypes.arrayOf(sortFilterShape),
      openStatus: PropTypes.bool,
      openConst: PropTypes.string,
      onChange: PropTypes.func
    }).isRequired,
    sortFilterType: PropTypes.shape({
      handleDropdownClose: PropTypes.func,
      handleDropdownOpen: PropTypes.func,
      defaultFilter: viewFilterShape,
      filterCollection: PropTypes.arrayOf(viewFilterShape),
      openStatus: PropTypes.bool,
      openConst: PropTypes.string,
      onChange: PropTypes.func
    }).isRequired,
    currentViewFilter: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        sortFn: PropTypes.func
      }),
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        viewFn: PropTypes.func
      })
    ]).isRequired,
    currentSortFilter: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        sortFn: PropTypes.func
      }),
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        viewFn: PropTypes.func
      })
    ]).isRequired,
    dropdownOpen: PropTypes.string
  }).isRequired,
  searchProps: PropTypes.shape({
    clearValue: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string
  }).isRequired,
  toggleProps: PropTypes.shape({
    handleViewToggle: PropTypes.func
  }).isRequired,
  currentView: PropTypes.string.isRequired,
  constants: PropTypes.shape().isRequired,
  onKeyPressEnter: PropTypes.func,
  placeholder: PropTypes.string
};

Header.defaultProps = {
  hideViewToggle: false,
  hideViewFilter: false,
  hideSearch: false,
  hideSortFilter: false,
  hideFilters: false,
  searchLabelText: 'Search Items',
  helpText: undefined,
  searchOnClick: () => {},
  onKeyPressEnter: () => {},
  placeholder: ''
};

export default Header;
